import styled from '@emotion/styled';

import { EnrolmentStatus } from '@/api';

interface Props {
  status?: EnrolmentStatus;
}

const dict = {
  [EnrolmentStatus.Error]: { color: 'var(--core-red)', text: 'Error' },
  [EnrolmentStatus.Created]: { color: 'var(--dark-blue)', text: 'Created' },
  [EnrolmentStatus.EnrolRequested]: { color: 'var(--orange)', text: 'Enrol requested' },
  [EnrolmentStatus.Enroled]: { color: 'var(--dark-green)', text: 'Enrolled' },
  [EnrolmentStatus.EnrolFailed]: { color: 'var(--core-red)', text: 'Enrol failed' },
  [EnrolmentStatus.UnEnrolRequested]: { color: 'var(--orange)', text: 'Un-enrol requested' },
  [EnrolmentStatus.Unenroled]: { color: 'var(--light-blue)', text: 'Un-enrolled' },
  [EnrolmentStatus.UnenrolFailed]: { color: 'var(--core-red)', text: 'Un-enrol failed' },
  [EnrolmentStatus.EnrolIgnored]: { color: 'var(--orange)', text: 'Enrol ignored' },
};

export const CustomerStatus = ({ status }: Props) => {
  const { color, text } = status ? dict[status] : { color: 'var(--white)', text: '' };

  return (
    <StyledStatus>
      <StyledIndicator color={color} />
      <StyledText>{text}</StyledText>
    </StyledStatus>
  );
};

const StyledStatus = styled.div`
  align-items: center;
  border-radius: 18px;
  color: var(--indigo);
  display: inline-flex;
  justify-content: center;
  gap: 6px;
  min-width: 130px;
  padding: 6px 16px 6px 6px;
`;

const StyledIndicator = styled.div<{ color: string }>`
  border-radius: 50%;
  height: 17px;
  width: 17px;

  background-color: ${(props) => props.color};
`;

const StyledText = styled.span`
  font-weight: bold;
  white-space: nowrap;
`;
